import NumberFlow from "@number-flow/react"
import { formatNumber } from "accounting"
import { Flex, Tooltip, Typography } from "antd"
import cls from "classname"

import InfoTooltip from "../../../../../Components/InfoTooltip/InfoTooltip"
import Private from "../../../../../Components/Private"
import { useAnimatedNumber } from "../../../../../hooks/useAnimatedNumber"

import "./MetricsRow.less"

const { Text } = Typography

const MetricBlock = ({ block, dataType, isRestricted, isComparisonVisible }) => {
  const animatedValue = useAnimatedNumber(block.value)
  const isRate = dataType === "rate"
  const hasValue = block.value || block.value === 0

  const valueNode = isRestricted ? (
    "-"
  ) : hasValue ? (
    <NumberFlow
      value={animatedValue}
      suffix={isRate ? "%" : ""}
      format={
        isRate
          ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
          : { maximumFractionDigits: 0 }
      }
    />
  ) : (
    "-"
  )

  const comparisonValue = block.comparisonValue ?? 0
  const comparisonText = isRate
    ? `${formatNumber(comparisonValue, 2, ",", ".")}%`
    : formatNumber(comparisonValue, 0, ",", ".")

  const showComparison = !isRestricted && isComparisonVisible

  return (
    <Flex gap={8} align="flex-start" className="chart-legend">
      <div className={cls("legend-color", { dashed: block.isDashed })}>
        <div
          className={cls("color", { dashed: block.isDashed })}
          style={{
            background: block.isDashed
              ? `repeating-linear-gradient(to right, ${block.color} 0 4px, transparent 4px 8px)`
              : block.color
          }}
        />
      </div>
      <Flex gap={4} vertical>
        <Flex align="center" gap={6} className="metric-block__title">
          <Text type="secondary" strong>
            {block.title}
          </Text>
          {/* 3DS Usage is the only metric that carries a polarity marker (§1 R14). */}
          {block.marker && <span className="metric-block__marker">{block.marker}</span>}
          {block.tooltip && <InfoTooltip title={block.tooltip} />}
        </Flex>
        <Text
          strong
          className="chart-total-value"
          style={isRestricted ? { fontWeight: 400 } : undefined}
        >
          {block.valueTooltip && !isRestricted ? (
            <Tooltip title={block.valueTooltip}>{valueNode}</Tooltip>
          ) : block.isPrivate ? (
            <Private disabled={!isRate}>{valueNode}</Private>
          ) : (
            valueNode
          )}
        </Text>
        {showComparison && (
          <Text type="secondary" className="chart-total-comparison">
            {block.isPrivate ? (
              <Private disabled={!isRate}>{comparisonText}</Private>
            ) : (
              comparisonText
            )}{" "}
            {block.comparisonLabel || "previous period"}
          </Text>
        )}
      </Flex>
    </Flex>
  )
}

const MetricsRow = ({ metrics = [], dataType, isRestricted, isComparisonVisible }) => {
  return (
    <div className="metrics-row">
      <Flex gap={36} wrap="wrap" className="metrics-row__metrics">
        {metrics.map((block) => (
          <MetricBlock
            key={block.title}
            block={block}
            dataType={dataType}
            isRestricted={isRestricted}
            isComparisonVisible={isComparisonVisible}
          />
        ))}
      </Flex>
    </div>
  )
}

export default MetricsRow
